/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkAddDocumentDto } from '../models/work-add-document-dto';
import { WorkCreateEquipmentlogtypeDto } from '../models/work-create-equipmentlogtype-dto';
import { WorkDropdownOptionDto } from '../models/work-dropdown-option-dto';
import { WorkEquipmentlogtype } from '../models/work-equipmentlogtype';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkRemoveDocumentDto } from '../models/work-remove-document-dto';
import { WorkSuccessDto } from '../models/work-success-dto';
import { WorkUpdateEquipmentlogtypeDto } from '../models/work-update-equipmentlogtype-dto';

@Injectable({ providedIn: 'root' })
export class WorkEquipmentlogtypesV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `equipmentlogtypesV2ControllerGetAllDropdownOptions()` */
  static readonly EquipmentlogtypesV2ControllerGetAllDropdownOptionsPath = '/v2/equipmentlogtypes/dropdown-options';

  /**
   * Required permissions: equipments:read, equipments:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `equipmentlogtypesV2ControllerGetAllDropdownOptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmentlogtypesV2ControllerGetAllDropdownOptions$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDropdownOptionDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEquipmentlogtypesV2Service.EquipmentlogtypesV2ControllerGetAllDropdownOptionsPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDropdownOptionDto>>;
      })
    );
  }

  /**
   * Required permissions: equipments:read, equipments:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `equipmentlogtypesV2ControllerGetAllDropdownOptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmentlogtypesV2ControllerGetAllDropdownOptions(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkDropdownOptionDto>> {
    return this.equipmentlogtypesV2ControllerGetAllDropdownOptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDropdownOptionDto>>): Array<WorkDropdownOptionDto> => r.body)
    );
  }

  /** Path part for operation `equipmentlogtypesV2ControllerFindAllPaginated()` */
  static readonly EquipmentlogtypesV2ControllerFindAllPaginatedPath = '/v2/equipmentlogtypes';

  /**
   * Required permissions: equipments:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `equipmentlogtypesV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmentlogtypesV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by isStatus query param.
     *           <p>
     *              <b>Format: </b> filter.isStatus={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.isStatus=$not:$like:John Doe&filter.isStatus=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.isStatus'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> name:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>name</li>
     * <li>description</li>
     * <li>allowStocklocation</li>
     * <li>isStatus</li></ul>
     */
      sortBy?: Array<'name:ASC' | 'name:DESC' | 'description:ASC' | 'description:DESC' | 'allowStocklocation:ASC' | 'allowStocklocation:DESC' | 'isStatus:ASC' | 'isStatus:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> 
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkEquipmentlogtype>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'isStatus'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEquipmentlogtypesV2Service.EquipmentlogtypesV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.isStatus', params['filter.isStatus'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkEquipmentlogtype>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'isStatus'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: equipments:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `equipmentlogtypesV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmentlogtypesV2ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by isStatus query param.
     *           <p>
     *              <b>Format: </b> filter.isStatus={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.isStatus=$not:$like:John Doe&filter.isStatus=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.isStatus'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> name:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>name</li>
     * <li>description</li>
     * <li>allowStocklocation</li>
     * <li>isStatus</li></ul>
     */
      sortBy?: Array<'name:ASC' | 'name:DESC' | 'description:ASC' | 'description:DESC' | 'allowStocklocation:ASC' | 'allowStocklocation:DESC' | 'isStatus:ASC' | 'isStatus:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> 
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkEquipmentlogtype>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'isStatus'?: (string | Array<string>);
};
};
}> {
    return this.equipmentlogtypesV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkEquipmentlogtype>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'isStatus'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkEquipmentlogtype>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'isStatus'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `equipmentlogtypesV2ControllerCreate()` */
  static readonly EquipmentlogtypesV2ControllerCreatePath = '/v2/equipmentlogtypes';

  /**
   * Required permissions: equipments:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `equipmentlogtypesV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  equipmentlogtypesV2ControllerCreate$Response(
    params: {
      body: WorkCreateEquipmentlogtypeDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkEquipmentlogtype>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEquipmentlogtypesV2Service.EquipmentlogtypesV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkEquipmentlogtype>;
      })
    );
  }

  /**
   * Required permissions: equipments:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `equipmentlogtypesV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  equipmentlogtypesV2ControllerCreate(
    params: {
      body: WorkCreateEquipmentlogtypeDto
    },
    context?: HttpContext
  ): Observable<WorkEquipmentlogtype> {
    return this.equipmentlogtypesV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkEquipmentlogtype>): WorkEquipmentlogtype => r.body)
    );
  }

  /** Path part for operation `equipmentlogtypesV2ControllerFindOneById()` */
  static readonly EquipmentlogtypesV2ControllerFindOneByIdPath = '/v2/equipmentlogtypes/{id}';

  /**
   * Required permissions: equipments:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `equipmentlogtypesV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmentlogtypesV2ControllerFindOneById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkEquipmentlogtype>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEquipmentlogtypesV2Service.EquipmentlogtypesV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkEquipmentlogtype>;
      })
    );
  }

  /**
   * Required permissions: equipments:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `equipmentlogtypesV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmentlogtypesV2ControllerFindOneById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkEquipmentlogtype> {
    return this.equipmentlogtypesV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkEquipmentlogtype>): WorkEquipmentlogtype => r.body)
    );
  }

  /** Path part for operation `equipmentlogtypesV2ControllerDelete()` */
  static readonly EquipmentlogtypesV2ControllerDeletePath = '/v2/equipmentlogtypes/{id}';

  /**
   * Required permissions: equipments:delete, equipments:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `equipmentlogtypesV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmentlogtypesV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEquipmentlogtypesV2Service.EquipmentlogtypesV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: equipments:delete, equipments:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `equipmentlogtypesV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmentlogtypesV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.equipmentlogtypesV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `equipmentlogtypesV2ControllerUpdate()` */
  static readonly EquipmentlogtypesV2ControllerUpdatePath = '/v2/equipmentlogtypes/{id}';

  /**
   * Required permissions: equipments:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `equipmentlogtypesV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  equipmentlogtypesV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateEquipmentlogtypeDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkEquipmentlogtype>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEquipmentlogtypesV2Service.EquipmentlogtypesV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkEquipmentlogtype>;
      })
    );
  }

  /**
   * Required permissions: equipments:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `equipmentlogtypesV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  equipmentlogtypesV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateEquipmentlogtypeDto
    },
    context?: HttpContext
  ): Observable<WorkEquipmentlogtype> {
    return this.equipmentlogtypesV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkEquipmentlogtype>): WorkEquipmentlogtype => r.body)
    );
  }

  /** Path part for operation `equipmentlogtypesV2ControllerAddDocumentToEquipmentlogtype()` */
  static readonly EquipmentlogtypesV2ControllerAddDocumentToEquipmentlogtypePath = '/v2/equipmentlogtypes/{id}/documents';

  /**
   * Required permissions: equipmentlogs:update, equipmentlogs:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `equipmentlogtypesV2ControllerAddDocumentToEquipmentlogtype()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  equipmentlogtypesV2ControllerAddDocumentToEquipmentlogtype$Response(
    params: {
      id: number;
      body: WorkAddDocumentDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEquipmentlogtypesV2Service.EquipmentlogtypesV2ControllerAddDocumentToEquipmentlogtypePath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: equipmentlogs:update, equipmentlogs:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `equipmentlogtypesV2ControllerAddDocumentToEquipmentlogtype$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  equipmentlogtypesV2ControllerAddDocumentToEquipmentlogtype(
    params: {
      id: number;
      body: WorkAddDocumentDto
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.equipmentlogtypesV2ControllerAddDocumentToEquipmentlogtype$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `equipmentlogtypesV2ControllerRemoveDocumentFromEquipmentlogtype()` */
  static readonly EquipmentlogtypesV2ControllerRemoveDocumentFromEquipmentlogtypePath = '/v2/equipmentlogtypes/{id}/documents';

  /**
   * Required permissions: equipmentlogs:delete, equipmentlogs:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `equipmentlogtypesV2ControllerRemoveDocumentFromEquipmentlogtype()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  equipmentlogtypesV2ControllerRemoveDocumentFromEquipmentlogtype$Response(
    params: {
      id: number;
      body: WorkRemoveDocumentDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEquipmentlogtypesV2Service.EquipmentlogtypesV2ControllerRemoveDocumentFromEquipmentlogtypePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: equipmentlogs:delete, equipmentlogs:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `equipmentlogtypesV2ControllerRemoveDocumentFromEquipmentlogtype$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  equipmentlogtypesV2ControllerRemoveDocumentFromEquipmentlogtype(
    params: {
      id: number;
      body: WorkRemoveDocumentDto
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.equipmentlogtypesV2ControllerRemoveDocumentFromEquipmentlogtype$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

}
